//
// 开关
// ============================================================
import Ns from "./utility";


let showHandle, hideHandle, timer = 0, timer2 = 0, bool = true, oldElement, activeElement, checkedText = [], checkedId = [], hideBool = true, showBool = true;

let listInit = (options, nowElement) => {
    if (ns(".list-wrapper").hasClass("active") && oldElement == nowElement) return;

    if(ns(".list-wrapper").length() == 0) {
        let list = `
            <div class="list-wrapper">
                <dl></dl>
            </div>
        `;
        ns("body").append(list);
    }

    if (oldElement != nowElement) {
        // 有值
        checkedText = [];
        checkedId = [];
        let selectedId = ns(nowElement).attr("data-selected-id");
        let selectedText = ns(nowElement).attr("data-selected-text");
        selectedId = selectedId && selectedId.indexOf(",") != -1 ? selectedId.split(",") : [selectedId];
        selectedText = selectedText && selectedText.indexOf(",") != -1 ? selectedText.split(",") : [selectedText];
        selectedText[0] != null ? checkedText = selectedText : "";
        selectedId[0] != null  ? checkedId = selectedId : "";

        let createDd = data => {
            return  `
                <dd class="item" data-id="`+ data.id +`">
                    <a href=`+ (data.href && !data.isDisabled ? data.href : "javascript:;") + ` class="` +  (data.isDisabled == true ? " disabled " : "") + (data.isSelected == true ? " active " : "") +`"><span class="item-text">`+ data.text +`</span></a>
                </dd>
            `;
        };

        let str = '';
        let ddLength = ns(".list-wrapper").find("dl").eq(0).find(".item").length();
        let dataLength = options.data.length;

        let dataSet = () => {
            let len = ddLength > dataLength && ddLength != dataLength ? ns(".list-wrapper").find("dl").eq(0).find(".item").get() : dataLength;
            Ns.each(len, (item, i) => {

                let id, isSelected, isDisabled, href, text;
                if(options.data[i]) {
                    id =  options.data[i].id ? options.data[i].id : i;
                    isDisabled = options.data[i].isDisabled ? options.data[i].isDisabled : false;
                    href = options.data[i].href ? options.data[i].href : false;
                    text = options.data[i].text ? options.data[i].text : "";
                    isSelected = checkedText.indexOf(text) >= 0 ? true : false;

                }

                if(ddLength == 0 || (dataLength > ddLength && ddLength != dataLength)) {
                    str += createDd({id, isSelected, isDisabled, href, text})

                }else if (dataLength <= ddLength && options.data[i]) {
                    let dd = ns(".list-wrapper").find("dl").eq(0).find(".item").eq(i).attr("data-id", id);
                    let a = dd.find("a").removeClass("active").removeClass("disabled");
                    isSelected ? a.addClass("active") : "";
                    isDisabled ? a.addClass("disabled") : "";
                    href && !isDisabled ? a.attr("href", href) : a.attr("href", "javascript:;");
                    a.find(".item-text").html(text);

                }else if(ddLength > dataLength && ddLength != dataLength) {
                    ns(item).remove();
                }
            }, true);
        };

        dataSet();

        if(ddLength == 0 || (dataLength > ddLength && dataLength != ddLength)) {
            ns(".list-wrapper").find("dl").eq(0).html(str);
        }

    }

    // 列表定位位置获取
    let getBoundingClientRect = nowElement.getBoundingClientRect();
    let x = getBoundingClientRect.left + window.pageXOffset;
    let y = getBoundingClientRect.bottom + window.pageYOffset;

    ns(".list-wrapper").css({
        top: y + "px",
        left: x + "px",
    }).addClass("active");

    // 宽度兼容性
    if(options.isRadio || options.isCheckbox) {
        ns(".list-wrapper").css("min-width", getBoundingClientRect.width + "px");
    }
    ns(".list-wrapper").css("max-width", window.innerWidth - getBoundingClientRect.left + "px");

    // 列表高度
    let listHeight = ns(".list-wrapper dl").find(".item").get(0).offsetHeight  * (options.data.length > 6 ? 6 : options.data.length);

    bool = true;

    // 列表定位竖轴兼容
    let bottom = window.innerHeight - getBoundingClientRect.bottom;
    // 定位在下，且空间充足
    if (bottom > listHeight) {
        ns(".list-wrapper dl").css("height", listHeight +"px");
    }else {

        // 定位在下，高度自适应
        if (getBoundingClientRect.bottom < window.innerHeight/2 ) {
            ns(".list-wrapper dl").css("height", bottom +"px");
        }

        // 定位在上，且空间充足
        if (getBoundingClientRect.top > listHeight) {
            ns(".list-wrapper").css("top", getBoundingClientRect.top - listHeight + window.pageYOffset + "px").find("dl").css("height", listHeight +"px");
        }else if (getBoundingClientRect.top < listHeight && getBoundingClientRect.bottom > window.innerHeight/2) {

            // 定位在上，高度自适应
            ns(".list-wrapper").css("top", window.pageYOffset + "px").find("dl").css("height", getBoundingClientRect.top +"px");
        }
    }

    // 列表横轴兼容
    let getBoundingClientRect2 = ns(".list-wrapper").get(0).getBoundingClientRect();
    if(window.innerWidth <= getBoundingClientRect2.right) {
        ns(".list-wrapper").css({
            left: "auto",
            right: 0
        })
    }

    // 不同数据滚动高度还原
    oldElement != nowElement ? Ns.each(ns(".list-wrapper dl").get(), item => item.scrollTop = 0 ) : ""

};

showHandle = function (ev, options, nowElement) {
    listInit(options, nowElement);
    clearTimeout(timer);
    clearTimeout(timer2);

    // 显示回调
    if(showBool && options.showCallback) {
        Ns.each(ns(options.el).get(), item => {
            if(item == nowElement) {
                options.showCallback.call(nowElement, ev);
                hideBool = true;
                showBool = false;
            }
        })
    }

    let len = options.data.length > 6 ? 6 : options.data.length;
    timer = timer2 = '';
    setTimeout( () => {
        Ns.each(len, (item, i) => {
            ns(".list-wrapper").find("dl").eq(0).css({
                transform: "scale(1)",
                opacity: 1
            })
        }, bool);
        setTimeout( () => {
            ns(".list-wrapper dl").eq(0).addClass("active");
        }, 288)
    }, 100);

    oldElement = nowElement;

    return true;
};

hideHandle = function (ev, options) {
    clearTimeout(timer);
    clearTimeout(timer2);
    timer = timer2 = "";

    let len = options.data.length >= 6 ? 6 : options.data.length;
    timer = setTimeout( () => {
        ns(".list-wrapper").find("dl").removeClass("active").css({
            transform: "scale(0)",
            opacity: 0
        });

        // 隐藏回调
        if (hideBool && options.hideCallback && activeElement) {
            Ns.each(ns(options.el).get(), item => {
                if (item == activeElement) {
                    options.hideCallback.call(activeElement, ev);
                    hideBool = false;
                    showBool = true;
                }
            });
        }

        timer2 = setTimeout( () => ns(".list-wrapper").removeClass("active").find("dl").removeClass("active"), 288)

    }, 500);

    return true;
};

const DropdownPublic = options => {
    new Ns({
        el: options.el,
        eventHandle: [{
            type: "click",
            callback: function (ev) {
                activeElement = this;
                return showHandle(ev, options, this);
            }
        }, {
            type: "mouseover",
            callback: function (ev) {
                clearTimeout(timer);
                clearTimeout(timer2);
                timer = timer2 = "";
                activeElement = this;
                if (options.isMouseover == true) return showHandle(ev, options, this);

            }
        }, {
            type: "mouseout",
            callback:  function (ev) {
                return hideHandle(ev, options);
            }
        }],
        load () {
            let defaultText = [];
            let defaultId = [];
            Ns.each(options.data, (data, i) => {
                if (data.isSelected == true) {
                    defaultId.push(data.id ? data.id : i);
                    defaultText.push(data.text);
                }
            });

            if (defaultText.length != 0) {
                ns(this).attr("data-selected-id", defaultId).attr("data-selected-text", defaultText).find(options.saveContentElement).text(defaultText);
            }
            checkedId = defaultId
            return true;
        }
    });

    new Ns({
        el: "body",
        eventHandle: [{
            type: "mouseover",
            entrust: ".list-wrapper",
            callback: function (ev) {
                clearTimeout(timer);
                clearTimeout(timer2);
                timer = timer2 = "";
                return true;
            }
        }, {
            type: "mouseout",
            entrust: ".list-wrapper",
            callback:  function (ev) {
                return hideHandle(ev, options);
            }
        }],
    });

    new Ns({
        el: ".list-wrapper",
        eventHandle: {
            type: "click",
            entrust: ".item",
            callback:  function (ev) {
                if(ns(this).find("a").hasClass("disabled")) return true;

                if(options.isRadio == true || options.isCheckbox == true) {
                    Ns.each(ns(options.el).get(), item => {
                        if(item == activeElement) {

                            // 单选
                            if (options.isRadio == true) {
                                ns(this).parent().find("a.active").removeClass("active");
                                let text = ns(this).find("a").addClass("active").find(".item-text").text();
                                let id = ns(this).attr("data-id");
                                ns(item).attr("data-selected-id", id).attr("data-selected-text", text);

                                options.saveContentElement == options.el ? ns(item).text(text) : ns(item).find(options.saveContentElement).text(text);

                            }else if(options.isCheckbox == true) {

                                // 多选取消
                                if (ns(this).find("a").hasClass("active")) {
                                    ns(this).find("a").removeClass("active");
                                    let index = checkedId.indexOf(ns(this).attr("data-id"));
                                    checkedId.splice(index, 1);
                                    checkedText.splice(index, 1);
                                    ns(item).attr("data-selected-id", checkedId).attr("data-selected-text", checkedText).find(options.saveContentElement).text(checkedText.length == 0 ? "请选择..." : checkedText);
                                }else {

                                    // 多选选择
                                    let text = ns(this).find("a").addClass("active").find(".item-text").text();
                                    checkedText.push(text);
                                    checkedId.push(ns(this).attr("data-id"));

                                    if (options.saveContentElement == options.el){
                                        ns(options.el).attr("data-selected-id", checkedId).attr("data-selected-text", checkedText).text(checkedText);
                                    }else {
                                        ns(options.el).attr("data-selected-id", checkedId).attr("data-selected-text", checkedText).find(options.saveContentElement).text(checkedText);
                                    }
                                }
                            }
                        }
                    });
                }
                return true;
            }
        },
    });
};
module.exports = DropdownPublic;


// WEBPACK FOOTER //
// src/js/dropdown-public.js